import type { ChangelogEntry } from "../types";

/** Rotere bilder og jevnere kort i lokasjonslista. */
export const LOKASJONER_ROTER_BILDER_2026_10: ChangelogEntry = {
  id: "2026-10-25-lokasjoner-roter-bilder",
  date: "2026-10-25",
  title: "Roter bilder på lokasjonene",
  summary: "Bilder som ligger på siden kan roteres, og kortene i lokasjonslista er større og like høye.",
  sections: [
    {
      heading: "Lokasjoner",
      minRole: "user",
      items: [
        {
          title: "Roter bilder",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Under «Rediger bilder» har hvert bilde valgene «Roter mot høyre» og «Roter mot venstre». Bildet lagres rotert, så det vises riktig overalt.",
        },
        {
          title: "Like store kort i lista",
          kind: "forbedret",
          featureFlag: "feature_locations",
          body: "Færre og større kort i bredden, og alle forsidebildene vises i samme utsnitt.",
        },
      ],
    },
  ],
};
